<template>
  <div v-if="keyName === 'members'" class="clinics-merge-block__options-row">
    <div v-for="clinic in mergeData" class="clinics-merge-block__option-holder">
      {{ `(${clinic.employeeCount})` }}
      <div v-for="member in clinic.employees" :style="{opacity: member.active ? 1 : 0.3}">
        <div v-if="member.name && member.name.trim()" class="text-body-1">- {{ member.name }}</div>
        <div v-else>- <v-icon>mdi-account-question</v-icon>
        </div>
      </div>
    </div>
  </div>
  <div v-else class="clinics-merge-block__options-row">
    <v-radio-group  v-model="indexValue" class="my-0 py-0" @change="changeValue" row hide-details>
      <div v-for="(clinic, index) in mergeData" class="clinics-merge-block__option-holder d-flex align-center">
        <v-radio :value="index" class="my-0">
          <template v-slot:label>
            <div v-if="keyName === 'status'">{{ statusValue(clinic[keyName]) }}</div>
            <div v-else>{{ `${clinic[keyName] ? clinic[keyName] : ''}` }}</div>
          </template>
        </v-radio>
      </div>
    </v-radio-group>
  </div>
</template>

<script>
  import {CLINICS_STATUS_VALUES} from '@/constants/clinicsTypes';

  export default {
    name: 'ClinicsMergeOption',

    props: ['keyName', 'mergeData'],

    data: function () {
      return {
        indexValue: null,
      };
    },

    methods: {
      statusValue: function (statusValue) {
        return CLINICS_STATUS_VALUES[statusValue];
      },
      changeValue: function () {
        if (this.mergeData[this.indexValue] !== undefined) {
          this.$emit('changeValue', this.mergeData[this.indexValue][this.keyName]);
        }
      },
      setValue: function (value) {
        this.indexValue = value;
        this.changeValue();
      },
    },
  };
</script>
